import React from 'react';
import { PageLoader } from 'src/lib/PageLoader';

export const AsyncContactPage = ({ ...props }): JSX.Element => (
  <PageLoader
    id='src/pages/ContactPage/ContactPage'
    componentImport={async () => (await import('src/pages/ContactPage/ContactPage'))}
    head={() => async () => {
      return {
        title: 'Contact Us',
        description: 'Contact Rock Island Auction Company for Questions About Antique and Collector Firearms Auctions',
      };
    }}
    {...props}
  />
);
